export class IpAreaSettingModel {
  constructor(data = {}) {
    const { ipAreaType, ipAreaIds } = data

    this.ipAreaType = ipAreaType
    this.ipAreaIds = ipAreaIds
  }

  static assign(data) {
    return new IpAreaSettingModel(data)
  }
}
